// Modules
import moment from "moment";

// Interfaces
import { ResortPointInterface } from "Interfaces/ResortPointInterface";

enum SortType {
    DESTINATION = "name",
    ROOMTYPE = "room",
    VIEWTYPE = "viewDescription",
};

const SORT_FIELDS = {
    [SortType.DESTINATION]: "name",
    [SortType.ROOMTYPE]: "room",
    [SortType.VIEWTYPE]: "viewDescription",
}

enum SortDirection {
    ASC = 'ascending',
    DESC = 'descending',
}


/**
 * Evaluate a sort for two villas based on View alphabetical ASCENDING
 */
function evalViewSortAsc(viewA: string = "", viewB: string = "") {
    const letterCompare = (viewA).localeCompare(viewB);

    // Sort by letters in View was successful
    if (letterCompare > 0) {
        return 1;
    } else if (letterCompare < 0) {
        return -1;
    }

    // Views are identical
    return 0;
}

/**
 * Evaluate a sort for two villas based on View alphabetical DESCENDING
 */
function evalViewSortDesc(viewA: string = "", viewB: string = "") {
    const letterCompare = (viewB).localeCompare(viewA);

    // Sort by letters in View was successful
    if (letterCompare > 0) {
        return 1;
    } else if (letterCompare < 0) {
        return -1;
    }

    // Views are identical
    return 0;
}


function sortResortPointCalculator(
    resorts: ResortPointInterface[],
    sortField?: SortType,
    sortDirection?: SortDirection
): any[] {
    let sortFunction: any
    switch (sortField) {
        // Sort by Destination
        case SortType.DESTINATION:
            if (sortDirection === SortDirection.ASC) {
                // Sort by Room ASC
                sortFunction = (a: any, b: any) => evalViewSortAsc(a[sortField], b[sortField]);
            } else {
                // Sort by Room DESC
                sortFunction = (a: any, b: any) => evalViewSortDesc(a[sortField], b[sortField]);
            }
            break;
        // Sort by view type
        case SortType.VIEWTYPE:
            if (sortDirection === SortDirection.ASC) {
                // Sort by View ASC
                sortFunction = (a: any, b: any) => evalViewSortAsc(a[sortField], b[sortField]);
            } else {
                // Sort by View DESC
                sortFunction = (a: any, b: any) => evalViewSortDesc(a[sortField], b[sortField]);
            }
            break;
        // Sort by room type
        case SortType.ROOMTYPE:
            if (sortDirection === SortDirection.ASC) {
                // Sort by Points ASC
                sortFunction = (a: any, b: any) => evalViewSortAsc(a[sortField], b[sortField]);
            } else {
                // Sort by Points DESC
                sortFunction = (a: any, b: any) => evalViewSortDesc(a[sortField], b[sortField]);
            }
            break;

        // default sort
        default:
        // sortFunction = (a:any, b:any) => contractIdSortAscFunc(a, b);
    }

    // Return the sorted resorts
    return resorts.sort(sortFunction);
}

export {
    sortResortPointCalculator,
    SortType,
    SortDirection,
};
